export enum TseAutomaticVatCalculation {
    NO_CALCULATION = 'noCalculation',
    NET_VALUE_CALCULATION = 'netValueCalculation',
    GROSS_VALUE_CALCULATION = 'grossValueCalculation',
}


